import _ from 'lodash';

/**
 * Determine which formatters are available for a given entity, based on the available formatters
 * and the preferred formatter.
 * @param formatters An array of all the formatters available for the entity type
 * @param formatterType {'detail' | 'create' | 'edit'} The formatter type that we are looking for
 * @param preferredFormatterId Optional, the ID of the formatter that is preferred, in case there are multiple
 * @param entityActions The entity actions available on the given entity, from e.g. useEntityActions
 * @returns {{editor: string, allEditors: string[]}|null} Null if there is no suitable editor, otherwise an object with the editor and all available editors
 */
const determineAvailableEntityEditors = (formatters, formatterType, preferredFormatterId, entityActions) => {
    const allEditors = _.filter(
        formatters,
        (f) => f.formatterType === formatterType && _.some(entityActions.availableFormatters, {formatterId: f.id}),
    );
    if (allEditors.length === 0) {
        return null;
    }

    const editor = preferredFormatterId
        ? _.find(allEditors, {id: preferredFormatterId})
        : allEditors.length === 1
        ? allEditors[0]
        : null;
    if (preferredFormatterId && !editor) {
        return null;
    }

    return {allEditors, editor};
};

export {determineAvailableEntityEditors};
